export default __webpack_public_path__ + "static/media/mobilityscore.747d3b37.svg";